import { CSSObject } from '@mui/material';

import { transparentize } from 'color2k';

import { primary, grey, red, yellow, blue, green } from '../../options/palette';

const hue = 500;

const hover = 0.9;
const active = 0.85;

const outlined: CSSObject = {
  // Color Styling
  outlinedPrimary: {
    'background': 'transparent',
    'backgroundColor': 'transparent',
    'borderColor': primary,
    'color': primary,

    '&.MuiLoadingButton-loading': {
      background: 'transparent',
      backgroundColor: 'transparent',
      borderColor: primary,
      color: primary
    },

    '&:hover': {
      background: transparentize(primary, hover),
      backgroundColor: transparentize(primary, hover),
      borderColor: primary,
      color: primary
    },

    '&:active': {
      background: transparentize(primary, active),
      backgroundColor: transparentize(primary, active),
      borderColor: primary,
      color: primary
    }
  },
  outlinedSecondary: {
    'background': 'transparent',
    'backgroundColor': 'transparent',
    'borderColor': grey[hue],
    'color': grey[hue],

    '&.MuiLoadingButton-loading': {
      background: 'transparent',
      backgroundColor: 'transparent',
      borderColor: grey[hue],
      color: grey[hue]
    },

    '&:hover': {
      background: transparentize(grey[hue], hover),
      backgroundColor: transparentize(grey[hue], hover),
      borderColor: grey[hue],
      color: grey[hue]
    },

    '&:active': {
      background: transparentize(grey[hue], active),
      backgroundColor: transparentize(grey[hue], active),
      borderColor: grey[hue],
      color: grey[hue]
    }
  },
  outlinedSuccess: {
    'background': 'transparent',
    'backgroundColor': 'transparent',
    'borderColor': green[hue],
    'color': green[hue],

    '&.MuiLoadingButton-loading': {
      background: 'transparent',
      backgroundColor: 'transparent',
      borderColor: green[hue],
      color: green[hue]
    },

    '&:hover': {
      background: transparentize(green[hue], hover),
      backgroundColor: transparentize(green[hue], hover),
      borderColor: green[hue],
      color: green[hue]
    },

    '&:active': {
      background: transparentize(green[hue], active),
      backgroundColor: transparentize(green[hue], active),
      borderColor: green[hue],
      color: green[hue]
    }
  },
  outlinedError: {
    'background': 'transparent',
    'backgroundColor': 'transparent',
    'borderColor': red[hue],
    'color': red[hue],

    '&.MuiLoadingButton-loading': {
      background: 'transparent',
      backgroundColor: 'transparent',
      borderColor: red[hue],
      color: red[hue]
    },

    '&:hover': {
      background: transparentize(red[hue], hover),
      backgroundColor: transparentize(red[hue], hover),
      borderColor: red[hue],
      color: red[hue]
    },

    '&:active': {
      background: transparentize(red[hue], active),
      backgroundColor: transparentize(red[hue], active),
      borderColor: red[hue],
      color: red[hue]
    }
  },
  outlinedInfo: {
    'background': 'transparent',
    'backgroundColor': 'transparent',
    'borderColor': blue[hue],
    'color': blue[hue],

    '&.MuiLoadingButton-loading': {
      background: 'transparent',
      backgroundColor: 'transparent',
      borderColor: blue[hue],
      color: blue[hue]
    },

    '&:hover': {
      background: transparentize(blue[hue], hover),
      backgroundColor: transparentize(blue[hue], hover),
      borderColor: blue[hue],
      color: blue[hue]
    },

    '&:active': {
      background: transparentize(blue[hue], active),
      backgroundColor: transparentize(blue[hue], active),
      borderColor: blue[hue],
      color: blue[hue]
    }
  },
  outlinedWarning: {
    'background': 'transparent',
    'backgroundColor': 'transparent',
    'borderColor': yellow[hue],
    'color': yellow[hue],

    '&.MuiLoadingButton-loading': {
      background: 'transparent',
      backgroundColor: 'transparent',
      borderColor: yellow[hue],
      color: yellow[hue]
    },

    '&:hover': {
      background: transparentize(yellow[hue], hover),
      backgroundColor: transparentize(yellow[hue], hover),
      borderColor: yellow[hue],
      color: yellow[hue]
    },

    '&:active': {
      background: transparentize(yellow[hue], active),
      backgroundColor: transparentize(yellow[hue], active),
      borderColor: yellow[hue],
      color: yellow[hue]
    }
  },

  // Sizes Styling
  outlinedSizeSmall: {
    'borderWidth': '1px',

    '&:hover': {
      borderWidth: '1px'
    },

    '&:active': {
      borderWidth: '1px'
    },

    '&.Mui-disabled': {
      'borderWidth': '1px',

      '&:hover': {
        borderWidth: '1px'
      },

      '&:active': {
        borderWidth: '1px'
      }
    }
  },
  outlinedSizeMedium: {
    'borderWidth': '2px',

    '&:hover': {
      borderWidth: '2px'
    },

    '&:active': {
      borderWidth: '2px'
    },

    '&.Mui-disabled': {
      'borderWidth': '2px',

      '&:hover': {
        borderWidth: '2px'
      },

      '&:active': {
        borderWidth: '2px'
      }
    }
  },
  outlinedSizeLarge: {
    'borderWidth': '2px',

    '&:hover': {
      borderWidth: '2px'
    },

    '&:active': {
      borderWidth: '2px'
    },

    '&.Mui-disabled': {
      'borderWidth': '2px',

      '&:hover': {
        borderWidth: '2px'
      },

      '&:active': {
        borderWidth: '2px'
      }
    }
  }
};

export default outlined;
